


window.onscroll = function () { scrollFunction() };

$headerSize = $('.navbar').outerHeight();
$("#MainContent").css("padding-top", $headerSize + "px")

$(document).ready(function(){
    scrollFunction();
})


function scrollFunction() {
    $headerSize = $('.navbar').outerHeight();


            if (document.body.scrollTop > $headerSize || document.documentElement.scrollTop > $headerSize) {
                $("header").addClass("scrolled");
                $("#MainContent").css("padding-top", $headerSize + "px");
            
        
            } else {
                $('header').removeClass("scrolled");
                $("#MainContent").css("padding-top", $headerSize + "px"); 
             }

}



$(".WinkelsOpeningstijden").click(function(){
    ToggleSideBar()
})

$("#closeWinkelsOpeningstijden").click(function(){
    ToggleSideBar()
})

$(function(){
    if (window.location.hash){
       var hash = window.location.hash.substring(1);
       if (hash == "show_stores"){
        ToggleSideBar()
       }
    }
    if(window.location.href.indexOf("show-stores") > -1){
        window.location.href = "https://flam-or.eu#show_stores";
    }
 });

 function ToggleSideBar(){
     var $html = $("html");
     var $sidebar = $("#shops_wrapper");
     $html.toggleClass("no_scroll")
     $sidebar.toggleClass("toggled");     
 }